// extracted by mini-css-extract-plugin
module.exports = {"avatarFile":"Avatar_avatarFile__16RSh","avatarCenter":"Avatar_avatarCenter__2SqpY","avatarContainer":"Avatar_avatarContainer__25ZbW","avatar":"Avatar_avatar__2sn8-"};